import { useContext } from 'react'
import { FolderNode } from './FolderNode.tsx'
import '@/core/popover/options/PopoverOptionsMenu.css'
import '@/core/app-shell/sidebar/collapsible-menu/SidebarCollapsableMenu.css'
import './CollectionsExplorer.css'
import { CollectionTreeContext } from './ICollectionTreeContext.tsx'
import { CollectionNode } from './CollectionNode.tsx'
import { isCollection } from '@/objects/gql/tree/HierarchyNodeModel.ts'
import type { FolderModel } from '@/core/gql/gql-models-override.ts'

interface HierarchyNodeProps {
  subtreeVersion: number
  level: number
  nodeId: string
}

export function HierarchyNode({ level, nodeId }: HierarchyNodeProps) {
  const { tree } = useContext(CollectionTreeContext)!
  const node = tree.idToNode.get(nodeId)
  if (!node) {
    return null
  }

  if (isCollection(node)) {
    return <CollectionNode level={level} collection={node} />
  } else {
    const children = tree.nodeToChildren.get(node.id) || []
    return (
      <FolderNode
        subtreeVersion={tree.idToSubtreeVersion.get(node.id)!}
        folder={node as FolderModel}
        level={level}
      >
        {children.map((id) => {
          return (
            <HierarchyNode
              subtreeVersion={tree.idToSubtreeVersion.get(id)!}
              key={id}
              nodeId={id}
              level={level + 1}
            />
          )
        })}
      </FolderNode>
    )
  }
}
